import { render, staticRenderFns } from "./SearchSpeech.vue?vue&type=template&id=6adf68ea&"
import script from "./SearchSpeech.vue?vue&type=script&lang=js&"
export * from "./SearchSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports